import { render, staticRenderFns } from "./taskRedirectDialog.vue?vue&type=template&id=efc404e8&"
import script from "./taskRedirectDialog.vue?vue&type=script&lang=js&"
export * from "./taskRedirectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports